import { IPublicSession, userSession } from 'state/session';
import { State } from 'utils/state';
import { voipRtcConnection } from 'utils/ui/rtc';

export function endSessionCallback(state: State<IPublicSession>) {
  state.on('session:end', () => {
    userSession().setValues({
      customerAllowed: false,
      streamActive: false,
    });

    voipRtcConnection?.destroy();
  });
}
